<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "payload.name") }}</strong-->
<!--        >" tag added by-->
<!--        <strong> {{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.tagAdded', { user: $_.get(activity, 'actorUser.name'), tag:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TagsAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
